/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/self-closing-comp */
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MdHome, MdSearch } from 'react-icons/md';
import {
  IoMdCart,
  IoMdChatboxes,
  IoMdNotifications,
  IoMdPerson,
} from 'react-icons/io';
import './Header.css';
import logo from '../../assets/Logo.png';

const Header = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const handleToggle = () => {
    setToggleMenu(!toggleMenu);
  };

  const closeMenu = () => {
    setToggleMenu(false);
  };
  return (
    <header className="header">
      <Link to="/home" className="header__logo">
        <img src={logo} alt="Haelo logo" />
      </Link>

      <div className={toggleMenu ? 'header__links active' : 'header__links'}>
        <NavLink
          activeClassName="selected"
          to="/home"
          className="header__item"
          onClick={closeMenu}
        >
          <MdHome size={24} />
          <p>Home</p>
        </NavLink>
        <NavLink
          activeClassName="selected"
          to="/explore"
          className="header__item"
          onClick={closeMenu}
        >
          <MdSearch size={24} />
          <p>Explore</p>
        </NavLink>
        <NavLink
          activeClassName="selected"
          to="/chats"
          className="header__item"
          onClick={closeMenu}
        >
          <IoMdChatboxes size={24} />
          <p>Chats</p>
        </NavLink>
        <NavLink
          activeClassName="selected"
          to="/store"
          className="header__item"
          onClick={closeMenu}
        >
          <IoMdCart size={24} />
          <p>Store</p>
        </NavLink>
        <NavLink
          activeClassName="selected"
          to="/profile"
          className="header__item"
          onClick={closeMenu}
        >
          <IoMdPerson size={24} />
          <p>Profile</p>
        </NavLink>
      </div>

      <span className={toggleMenu ? 'icon-container active' : 'icon-container'}>
        <IoMdNotifications size={24} />
      </span>
      <div
        onClick={handleToggle}
        role="button"
        tabIndex="0"
        className="header__toggle-container"
      >
        <div
          className={toggleMenu ? 'header__toggle animate' : 'header__toggle'}
        ></div>
      </div>
    </header>
  );
};

export default Header;
